__turbopack_context__.v({
  "background": "ECGBackground-module__EVnnqG__background",
});
